import { Link } from "react-router-dom";
import { Button, CardContent, Stack, Typography as T } from "@mui/material";
import useBasePath from "files/hooks/useBasePath";
import { LlamaIcon } from "~/assets/icons";

const FileNotFound = () => {
  const basePath = useBasePath();
  return (
    <CardContent
      sx={{
        border: "1px solid",
        borderColor: "grey.300",
        borderRadius: 2,
        bgcolor: "common.pageBackground",
      }}
    >
      <Stack gap={3} minHeight={300} alignItems="center" justifyContent="center">
        <LlamaIcon
          opacity={0.4}
          width={50}
          color="primary.dark"
          transform={"matrix(-1, 0, 0, 1, 0, 0), scale(1.2)"}
        />
        <T variant="body2">File not found</T>
        <Button component={Link} variant="contained" to={basePath}>
          Back to top directory
        </Button>
      </Stack>
    </CardContent>
  );
};

export default FileNotFound;
